import { router } from '@/helpers/router'
import { ChecklistStepView } from './checklist'
import { ChecklistStratum, ChecklistSteps } from './checklist.types'
import { emitter } from '@/services/mitt'

export function getChecklistSteps(stratum: ChecklistStratum): ChecklistSteps {
  const steps: ChecklistSteps = {
    read_first: new ChecklistStepView({
      id: 'read_first',
      title: 'Read your first guide',
      targetProgress: 5,
      onClick: (): void => {
        emitter.emit('checklistShowPopup')
      },
    }),
    highlight_idea: new ChecklistStepView({
      id: 'highlight_idea',
      title: 'Highlight an idea or try an exercise',
      onClick: (self, books): void => {
        const book = books.reading || books.recommendations[0]
        self.navigateAndShowHint(
          `/app/book/${book.url_slug}`,
          'Select a line that resonates, then tap on the "Highlight" option to save it. ' +
            'Alternatively, submit an exercise',
        )
      },
    }),
    save_three: new ChecklistStepView({
      id: 'save_three',
      title: 'Save 3 guides you want to read',
      targetProgress: 3,
      onClick: (self): void => {
        self.navigateAndShowHint(
          '/app/search',
          'Search for guides that you find interesting, then tap on the bookmark icon and select "Add to Want to Read".',
        )
      },
    }),
    read_second: new ChecklistStepView({
      id: 'read_second',
      title: 'Read a second guide for 5 minutes',
      targetProgress: 5,
      onClick: (): void => {
        emitter.emit('checklistShowPopup')
      },
    }),
  }

  if (stratum === 'free') {
    steps.start_trial = new ChecklistStepView({
      id: 'start_trial',
      title: 'Unlock everything, start your free trial',
      onClick: (): void => {
        router().push('/app/billing')
      },
    })
  }

  return steps
}
